module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/balcony/painted.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/balcony/painted.jpg
// module id = 512
// module chunks = 0